import { Box, Card, Grid, Typography, Button, Tooltip, IconButton } from '@mui/material'
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ErrorIcon from '@mui/icons-material/Error';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import moment from 'moment';
import { addCommas } from '../../utils/functions/commas';
import { PictureAsPdf, QrCode2 } from '@mui/icons-material';

function CardInvoiceList({ row, onPay, onShowQrCode, onShowPDF }) {
    // console.log("row",row)
  return (
    <Card
    sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: '#f5f5f5',
    }}
    >
        <Box
            sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
            }}
        >
            <Chip
            icon={row.isLate ? <AccessTimeFilledIcon /> : <ErrorIcon /> }
            label={row.isLate ? 'ยังไม่เกินกำหนด' : 'เกินกำหนด'}
            color={row.isLate ? 'success' : 'error'}
            size="small"
            sx={{ color: '#ffffff' }}
            />
            <Typography variant="caption" color="text.secondary">
            {moment(row.inv_due_date).utc().format('DD MMM YYYY')}
            </Typography>
        </Box>

        <Typography variant="subtitle1" fontWeight="bold">
            {/* {row.so_name || 'ไม่มีชื่อบริการ'} */}
            {row.descriptions || 'ไม่มีชื่อบริการ'}
        </Typography>

        {/* <Typography variant="body2" color="text.secondary" gutterBottom>
            {row.merchant_name || 'ไม่มีชื่อบัญชี'}
        </Typography> */}

        <Divider sx={{ my: 1 }} />

        <Grid container>
            <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
                เลขที่ใบแจ้งหนี้
            </Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'right' }}>
            <Typography variant="body2">{row.invoice_no}</Typography>
            </Grid>

            <Grid item xs={6} sx={{ mt: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
                จำนวนเงิน
            </Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'right', mt: 0.5 }}>
            <Typography variant="body2" color="primary" fontWeight="bold">
                {addCommas(row.total_amount, 2)}
            </Typography>
            </Grid>
        </Grid>

        <Box sx={{ textAlign: 'right', mt: 2, display: 'flex', gap: 1, justifyContent: 'space-between' }}>
            {/* <Button
            variant='contained'
            size='small'
            sx={{ color: '#FFFFFF', borderRadius: 20 }}
            color='primary'
            >
            รายยละเอียด
            </Button> */}
            <Box>
                <Tooltip title="ดู Invoice" arrow>
                <span>
                    <IconButton
                        onClick={() => onShowPDF(row.order_id)}
                    >
                    <PictureAsPdf
                        color='primary'
                    />
                    </IconButton>
                </span>
                </Tooltip>
                <Tooltip title="ดู QR Code" arrow>
                <span>
                    <IconButton
                        onClick={() => onShowQrCode(row._id)}
                    >
                    <QrCode2 
                        color='primary'
                    />
                    </IconButton>
                </span>
                </Tooltip>
            </Box>

            <Button
            variant="contained"
            size="small"
            sx={{ color: '#FFFFFF', borderRadius: 20 }}
            color="primary"
            onClick={() => onPay(row)}
            >
            <CreditCardIcon sx={{ fontSize: 14, mr: '4px' }}/>
            ชำระเงิน
            </Button>
        </Box>
    </Card>
  )
}

export default CardInvoiceList